import React from 'react';
import styles from './styles.module.scss';

type NewsItem = {
  id: string;
  title: string;
  category: string;
  href: string;
};

type Props = {
  count?: number;
  viewAllHref?: string;
  isBlog?: boolean;
  newsItems: NewsItem[];
};

const NewsSection: React.FC<Props> = ({ count, viewAllHref, isBlog, newsItems }) => {
  const displayItems = count ? newsItems.slice(0, count) : newsItems;

  return (
    <>
      <div className={styles.header}>
        <h2 className={styles.title}>{isBlog ? 'BLOG' : 'NEWS'}</h2>
        {viewAllHref && (
          <a href={viewAllHref} className={styles.viewAllLink}>
            <span>すべて見る</span>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={styles.viewAllIcon}
            >
              <circle cx="14" cy="14" r="13.5" stroke="currentColor" />
              <path d="M8.55908 14.0078H19.0291" stroke="currentColor" strokeLinecap="round" />
              <path
                d="M15.3242 10.707L19.4419 14.0012"
                stroke="currentColor"
                strokeLinecap="round"
              />
              <path
                d="M15.3242 17.3019L19.4419 14.0078"
                stroke="currentColor"
                strokeLinecap="round"
              />
            </svg>
          </a>
        )}
      </div>
      <div className={styles.newsList}>
        {displayItems.map((item) => (
          <a key={item.id} href={item.href} className={styles.newsItem}>
            <div className={styles.newsContent}>
              <div className={styles.categoryTag}>{item.category}</div>
              <p className={styles.newsTitle}>{item.title}</p>
            </div>
          </a>
        ))}
      </div>
    </>
  );
};

export default NewsSection;
